/* @jsx h */
/* @jsxFrag Fragment */
/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import { h, Fragment } from 'preact';
import './index.app-shell.css';
import { MoverDropdown } from './mover-dropdown';
import '@updater/ui-fa-icon';

const ENTER_KEY = 13;

export const AppHeader = ({
  whiteLabel,
  updater = {},
  professionals = [],
  companies = [],
  onSignIn,
  showPoweredBy,
  poweredByUrl,
  logoClickEnabled,
  onLogoClick,
  routerGo,
  analytics,
  moverDropdown,
  showMoverDropdown,
  disableMoverDropdown,
} = {}) => {
  return (
    <>
      <div id="app-shell-header">
        <div class="container">
          <div
            class="branding-container"
            {...(logoClickEnabled
              ? {
                  tabIndex: 0,
                  onClick: onLogoClick,
                  onKeyPress: e => {
                    if (e.keyCode === ENTER_KEY) {
                      onLogoClick();
                    }
                  },
                }
              : {})}
          >
            {!showPoweredBy && (
              <img
                {...{
                  class: (whiteLabel || updater).className,
                  alt: `${(whiteLabel || updater).displayName} Logo`,
                  src: (whiteLabel || updater).logoUrl,
                }}
              />
            )}
            {companies.map((entity, index) => (
              <img
                key={index}
                class="company-logo"
                alt={entity.teamName}
                src={entity.formattedUrl}
              />
            ))}
            {professionals.map((entity, index) => (
              <div class="professional-container" key={index}>
                {entity.logoId && (
                  <img
                    class="professional-logo"
                    alt={entity.teamName}
                    src={entity.formattedUrl}
                  />
                )}
                <div class="professional-info">
                  <div class="professional-name">{entity.name}</div>
                  <div class="professional-description">
                    {entity.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {!onSignIn && showMoverDropdown && !disableMoverDropdown && (
            // If the onSignIn customization is unset, show moverDropdown
            <MoverDropdown
              title={moverDropdown.title}
              menuItems={moverDropdown.menuItems}
              routerGo={routerGo}
              analytics={analytics}
            />
          )}
          {onSignIn && (
            <div class="sign-in-link">
              <a onClick={onSignIn}>Sign In</a>
            </div>
          )}
          {showPoweredBy && (
            <img
              class="powered-by-logo"
              src={poweredByUrl}
              alt="Powered by Updater"
            />
          )}
        </div>
      </div>
      <div id="app-shell-header-space" />
    </>
  );
};
